import { createSelector } from 'reselect'

import {
  APP_TITLE,
  ADMIN_TABS,
  PUBLIC_MENU,
  PUBLIC_MENU_LOGGED_IN,
  ADMIN_GUEST_MENU,
  ADMIN_USER_MENU,
} from 'settings'

import projectSelectors from './project'
import auth from './auth'
import router from './router'

const color = createSelector(
  projectSelectors.currentProject,
  (project) => {
    if(!project || !project.meta || !project.meta.color) return null
    return project.meta.color
  }
)

const title = createSelector(
  projectSelectors.currentProject,
  (project) => {
    return project && project.name ? project.name : 'Booking System'
  }
)

const logo = createSelector(
  projectSelectors.currentProject,
  (project) => {
    if(!project || !project.meta || !project.meta.logo) return null
    return project.meta.logo
  }
)

const showMenus = createSelector(
  router.meta,
  meta => meta.showMenus,
)

const menu = createSelector(
  router.route,
  auth.data,
  projectSelectors.userRole,
  (route, user, userRole) => {
    let MENU = user ?
      PUBLIC_MENU_LOGGED_IN(user, userRole) :
      PUBLIC_MENU()

    if(route.name.indexOf('admin.') == 0) {
      MENU = user ?
        ADMIN_USER_MENU(user, userRole) :
        ADMIN_GUEST_MENU()
    }

    return MENU
  }
)

const adminTabs = createSelector(
  auth.data,
  projectSelectors.userRole,
  (user, userRole) => ADMIN_TABS(user, userRole)
)

const selectors = {
  color,
  title,
  logo,
  menu,
  showMenus,
  adminTabs,
}

export default selectors
